import { render, staticRenderFns } from "./BusinessDataFormStep.vue?vue&type=template&id=f1c2320e&"
import script from "./BusinessDataFormStep.vue?vue&type=script&lang=js&"
export * from "./BusinessDataFormStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports